'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var RightSideToggleElement = function (props) {
    var right = props.right, left = props.left, _a = props.rightVisible, rightVisible = _a === void 0 ? false : _a;
    return (React__default.createElement(styledComponents.Container, null,
        left,
        rightVisible && right));
};

module.exports = RightSideToggleElement;
